import { inputStyles } from '../Input';

export default function CheckWrapper(props: Component.DefaultProps) {
  return <div className={inputStyles.wrapper.checkWrapper} children={props.children} style={props.style} />;
}
